module.exports = __webpack_public_path__ + "static/media/add_code_key.fa71c9ac.svg";